import { Box, Link, Paper } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { Hub } from 'aws-amplify';
import React, { useEffect } from "react";
import ProjectVersionInput from "../package.json";
import { AuthProvider } from "./components/auth/AuthContext";
import { AppDataContextProvider } from "./components/context/app-data-context";
import { useThemeMode } from "./components/theme";
import { SnackbarProvider } from "./components/toast";
import { THEME_MODES } from "./helpers/constant";
import AppHeaderBar from "./layout/header";
import DrawerSideBar from "./layout/sidebar";
import AppRoutes from "./routes/routes";
import Utils from "./utils";

const ProjectVersion = ProjectVersionInput.version;
const sizeOfMenuDrawer = 100;

function App() {
    const [snackText, setSnackText] = React.useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [isAdmin, setIsAdmin] = React.useState(false);
    const [isUser, setIsUser] = React.useState(false);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const { colours } = useThemeMode();

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    useEffect(() => {
        Hub.listen("snackbar", ({ payload: { message } }) => {
            if (message === null) setSnackOpen(false);
            else {
                setSnackText(message);
                setSnackOpen(true);
            }
        });
        Utils.getUserName().then((z) => setIsUser(true));
    }, []);

    return (
        <AuthProvider>
            <AppDataContextProvider>
                <SnackbarProvider>
                    {/* Skip to Content Link */}
                    <Link
                        href="#main-content"
                        sx={(theme)=>({
                            position: "absolute",
                            top: 0,
                            left: { xs: "0", md: `${sizeOfMenuDrawer}px` },
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            padding: "8px 16px",
                            zIndex: 1000,
                            transform: "translateY(-100%)",
                            transition: "transform 0.3s",
                            '&:focus': {
                                transform: "translateY(0%)",
                            }
                        })}
                    >
                        Skip to Content
                    </Link>

                    <DrawerSideBar
                        sizeOfMenuDrawer={sizeOfMenuDrawer}
                        ProjectVersion={ProjectVersion}
                        isAdmin={isAdmin}
                        mobileOpen={mobileOpen}
                        handleDrawerTransitionEnd={handleDrawerTransitionEnd}
                        handleDrawerClose={handleDrawerClose}
                    />
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        open={snackOpen}
                        autoHideDuration={6000}
                        onClose={() => setSnackOpen(false)}
                        message={snackText}
                    />
                    <Paper
                        sx={(theme) => ({
                            display: "flex",
                            flexDirection: "column",
                            minHeight: "100vh",
                            height: {
                                xs: "100vh",
                                '@media (max-height: 600px)': {
                                    height: '100%',
                                },
                            },
                            paddingLeft: { xs: "0", md: `${sizeOfMenuDrawer}px` },
                            backgroundColor: theme.palette.mode === THEME_MODES.LIGHT ? colours.basegray : colours.gray80
                        })}
                    >
                        <AppHeaderBar
                            setIsAdmin={(d) => setIsAdmin(d)}
                            handleDrawerToggle={handleDrawerToggle}
                        />
                        <Box display="flex" flexDirection="column" component="main" id="main-content" tabIndex={-1} flexGrow={1} overflow="auto">
                            <AppRoutes isUser={isUser} />
                        </Box>
                    </Paper>
                </SnackbarProvider>
            </AppDataContextProvider>
        </AuthProvider>
    );
}

export default App;
